import { request_get_wall } from '../posts.services'
import {
    ResponseGetWall,
    Datum,
    Tag,
} from '../interfaces/posts.interface/posts.getwall.interface'
import { Platform } from 'react-native'

const CACHE_KEY = 'web_posts_wall_cache_v1'
const CACHE_TTL_MS = 5 * 60 * 1000 // 5 minutos

interface CachedData {
    timestamp: number
    response: ResponseGetWall['single']
}

const readCache = (): CachedData | null => {
    if (Platform.OS !== 'web') return null
    try {
        const raw = localStorage.getItem(CACHE_KEY)
        if (!raw) return null
        const parsed: CachedData = JSON.parse(raw)
        if (Date.now() - parsed.timestamp > CACHE_TTL_MS) return null
        return parsed
    } catch {
        return null
    }
}

const writeCache = (single: ResponseGetWall['single']) => {
    if (Platform.OS !== 'web') return
    try {
        const payload: CachedData = { timestamp: Date.now(), response: single }
        localStorage.setItem(CACHE_KEY, JSON.stringify(payload))
    } catch {}
}

export interface FetchWallOptions {
    authToken: string
    version?: string | null
    page?: string | null
    size?: string | null
    force?: boolean
}

export const fetchWallWeb = async (opts: FetchWallOptions) => {
    if (Platform.OS !== 'web')
        throw new Error('fetchWallWeb solo debe llamarse en Web')
    const cache = !opts.force && readCache()
    if (cache) {
        // debug suprimido: Using cache
        return cache.response
    }

    // debug suprimido: Fetching from server
    const data = await request_get_wall({
        authToken: opts.authToken,
        version: opts.version,
        page: opts.page ?? '0',
        size: opts.size ?? '100',
    })

    // debug suprimido: Server response

    if (data?.single) writeCache(data.single)
    try {
        const rx = (data?.single as any)?.reactions || []
        // debug suprimido: FIX REACTIONS fetchWallWeb
    } catch {}
    return data?.single
}

export const getCachedPosts = (): Datum[] => {
    const c = readCache()
    return c?.response?.data || []
}
export const getCachedLabels = (): Tag[] => {
    const c = readCache()
    return c?.response?.tags || []
}
export const getCachedReactions = (): any[] => {
    const c = readCache()
    const ret = (c?.response as any)?.reactions || []
    try {
        // debug suprimido: FIX REACTIONS getCachedReactions
    } catch {}
    return ret
}
export const clearWallCache = () => {
    if (Platform.OS === 'web') localStorage.removeItem(CACHE_KEY)
}

export const getTotalPosts = () => {
    const c = readCache()
    return c.response.total
}
